import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export const RunTenantSql = async (payload: {
  tenant_id: string;
  sql: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/sql-tool/run`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to run query.",
      data: null,
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetTenantTables = async (
  params?: { tenant_id?: string },
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/sql-tool/tables`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load tables.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const GetTenantSchema = async (
  params?: { tenant_id?: string },
): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.get(`/sql-tool/schema`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load schema.",
      data: null,
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};